import ProjectVariables from "./ProjectVariables";

export default ProjectVariables;
